import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface LocationDialogProps {
  open: boolean;
  onClose: () => void;
  mode: string;
  editLocationId: number | null;
  editLocationName: string;
  onSave: () => void;
  setLocationName: React.Dispatch<React.SetStateAction<string>>;
}

const AddEditDialog: React.FC<LocationDialogProps> = ({
  open,
  onClose,
  mode,
  editLocationId,
  editLocationName,
  onSave,
  setLocationName,
}) => {
  const { t } = useTranslation();

  // Assume editData is an object containing values when editing
  useEffect(() => {
    if (editLocationId) {
      setLocationName(editLocationName);
    }
  }, [editLocationId]); // Runs when editData changes

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: { xs: "90%", sm: "600px" },
          maxWidth: "100%",
        },
      }}
    >
      <DialogTitle className="dialogtitle">
        <Typography>
          {mode === "add" ? t("add_location_class") : t("edit_location_class")}
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          sx={{
            margin: "auto",
            position: "absolute",
            right: "25px",
            top: "17px",
            border: "1px solid #be1e2d",
            color: "#be1e2d",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            "&:hover": {
              backgroundColor: "#be1e2d",
              color: "#ffffff",
            },
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <FormControl fullWidth>
          <FormLabel sx={{ mb: 1, color: "text.secondary", fontWeight: 500 }}>
            {t("location_class_name")}
          </FormLabel>
          <TextField
            value={editLocationName}
            onChange={(e) => setLocationName(e.target.value)}
            size="small"
            variant="outlined"
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ p: 2.5 }}>
        <Button onClick={onClose} className="cancelbtn">
          {t("cancel")}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSave}
          className="addbtn"
        >
          {mode === "add" ? t("add") : t("update")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddEditDialog;
